import { useCallback, useState } from "react";
import Header from "./components/Header";
import BreakingTicker from "./components/BreakingTicker";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import DeepDive from "./components/DeepDive";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

function scrollToFeed() {
  document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
}

export default function Home() {
  const [category, setCategory] = useState("all");
  const [query, setQuery] = useState("");

  const pickCategory = useCallback((id: string) => {
    setQuery("");
    setCategory(id);
    scrollToFeed();
  }, []);

  const handleSearch = useCallback((q: string) => {
    setCategory("all");
    setQuery(q.trim());
    scrollToFeed();
  }, []);

  const handleKeyword = useCallback((k: string) => {
    setCategory("all");
    setQuery(k);
    if (k) scrollToFeed();
  }, []);

  return (
    <div id="app-top">
      <Header onSearch={handleSearch} onPick={pickCategory} />
      <BreakingTicker />

      <main className="flex flex-col gap-12 pb-4 pt-2 md:gap-16 md:pb-6">
        <Hero />
        <Feed
          category={category}
          query={query}
          setCategory={setCategory}
          onKeyword={handleKeyword}
        />
        <DeepDive />
        <Faq />
        <About />
      </main>

      <Footer onPickCategory={pickCategory} />
      <BackToTop />
    </div>
  );
}